<template>
  <div id="admin">
    <v-container fluid>
      <v-row class="justify-center">
        <v-col
          cols="12"
          md="6"
        >

          <v-textarea
            solo
            name="input-pt"
            label="Insert input here - pt"
            v-show="language === 'pt' || both"
            v-model="post.textPt"
          ></v-textarea>

          <v-textarea
            solo
            name="input-en"
            label="Insert input here - en"
            v-show="language === 'en' || both"
            v-model="post.textEn"
          ></v-textarea>

          <v-file-input
            small-chips
            show-size
            counter
            accept="image/*"
            label="Image input w/ small chips"
            @change="convert($event)"
            ref="imgInput"
          ></v-file-input>

          <v-file-input
            small-chips
            show-size
            counter
            v-show="!saveCapturedVideo"
            accept="video/*"
            label="Video input w/ small chips"
            @change="convert($event)"
            ref="videoInput"
          ></v-file-input>

          <div
            class=""
            id="audio-video-capture"
          >
            <v-btn
              v-show="saveCapturedVideo"
              color="blue lighten-2"
              @click="resetVideoCapture()"
            >
              <v-icon>mdi-delete</v-icon>
              Clear Captured Video
            </v-btn>

            <v-btn
              v-show="audioFile"
              color="blue lighten-2"
              @click="resetAudioCapture()"
            >
              <v-icon>mdi-delete</v-icon>
              Clear Captured Audio
            </v-btn>

            <v-dialog
              v-model="dialog"
              width="500"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  color="red lighten-2"
                  v-on="on"
                  @click="resetVideoCapture()"
                  v-show="!videoFile && !cameraNotFound && !audioFile"
                >
                  <v-icon>mdi-camera</v-icon>
                  Record Video
                </v-btn>
              </template>

              <v-card>
                <v-card-title
                  class="headline grey lighten-2 justify-space-between"
                  primary-title
                >
                  Record Video

                  <v-btn
                    fab
                    @click="closeAndStopVideoCapture()"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>

                </v-card-title>

                <div
                  id="video-preview-area"
                  style="display: flex"
                >
                  <video
                    style="margin: 0 auto; width: 50%;"
                    ref="preview"
                    width="160"
                    height="120"
                    autoplay
                    muted
                  ></video>
                </div>

                <v-divider></v-divider>

                <v-card-actions :class="this.viewPortWidth < 550 ? 'flex-column' : null">
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    text
                    v-show="recordedVideo"
                    @click="setVideoForSave()"
                  >
                    <v-icon>mdi-play-circle</v-icon>
                    Set Video Recording
                  </v-btn>
                  <v-btn
                    color="primary"
                    text
                    @click="getVideoStreamAndStartRecording()"
                    v-show="!recording"
                  >
                    <v-icon>mdi-play-circle</v-icon>
                    Start Video Recording
                  </v-btn>

                  <v-btn
                    color="primary"
                    text
                    @click="resumeRecording()"
                    v-show="recording && !recordingResumed"
                  >
                    <v-icon>mdi-play</v-icon>
                    Resume Video Recording
                  </v-btn>
                  <v-btn
                    color="green"
                    text
                    @click="pauseRecording()"
                    v-show="recording && recordingResumed"
                  >
                    <v-icon>mdi-pause</v-icon>
                    Pause Video Recording
                  </v-btn>
                  <v-btn
                    color="red"
                    text
                    @click="stopRecording()"
                    v-show="recordingResumed || videoRecordingPaused"
                  >
                    <v-icon>mdi-stop</v-icon>
                    Stop Video Recording
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog
              id="audio-record"
              v-model="audioDialog"
              width="500"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  color="green lighten-2"
                  v-on="on"
                  @click="resetAudioCapture()"
                  v-show="!saveCapturedVideo"
                >
                  <v-icon>mdi-assistant</v-icon>
                  Record Audio
                </v-btn>
              </template>

              <v-card>
                <v-card-title
                  class="headline grey lighten-2 justify-space-between"
                  primary-title
                >
                  Record Audio

                  <v-btn
                    fab
                    @click="closeAndStopAudioCapture()"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>

                </v-card-title>

                <div
                  id="audio-preview-area"
                  style="display: flex"
                >
                  <audio
                    ref="audioEl"
                    controls
                  ></audio>
                </div>

                <v-divider></v-divider>

                <v-card-actions :class="this.viewPortWidth < 550 ? 'flex-column' : null">
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    text
                    v-show="audioFile"
                    @click="setAudioForSave()"
                  >
                    <v-icon>mdi-play-circle</v-icon>
                    Set Audio Recording
                  </v-btn>
                  <v-btn
                    color="primary"
                    text
                    @click="startAudioRecord()"
                    v-show="!recordingAudio"
                  >
                    <v-icon>mdi-play-circle</v-icon>
                    Start Audio Recording
                  </v-btn>

                  <v-btn
                    color="primary"
                    text
                    @click="resumeAudioRecording()"
                    v-show="recordingAudio && !audioRecordingResumed"
                  >
                    <v-icon>mdi-play</v-icon>
                    Resume Audio Recording
                  </v-btn>
                  <v-btn
                    color="green"
                    text
                    @click="pauseAudioRecording()"
                    v-show="recordingAudio && audioRecordingResumed"
                  >
                    <v-icon>mdi-pause</v-icon>
                    Pause Audio Recording
                  </v-btn>
                  <v-btn
                    color="red"
                    text
                    @click="stopAudioRecording()"
                    v-show="audioRecordingResumed || audioRecordingPaused"
                  >
                    <v-icon>mdi-stop</v-icon>
                    Stop Audio Recording
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>

          <v-alert
            v-show="serverResponse"
            :type="alertType"
            class="flex"
          >
            {{ serverResponse }}
            <v-btn
              dark
              color="purple"
              @click="dismissAlert(true)"
            >
              Dismiss
              <v-icon>mdi-minus</v-icon>
            </v-btn>
          </v-alert>

          <v-checkbox
            v-model="both"
            class="mx-2"
            label="Both"
          ></v-checkbox>

          <div
            id="change-language"
            v-show="!both"
          >

            <v-chip
              class="ma-2"
              color="primary"
            >
              English
            </v-chip>

            <v-switch
              v-model="languageSwitch"
              class="mx-2"
            ></v-switch>

            <v-chip
              class="ma-2"
              color="green"
              text-color="white"
            >
              Portuguese
            </v-chip>

          </div>

          <v-btn
            dark
            fab
            bottom
            right
            color="pink"
            @click="savePost()"
          >
            <v-icon>mdi-plus</v-icon>
            <v-overlay :value="overlay">
              <p v-if="overlayText"> {{ overlayText }} </p>
              <v-progress-circular
                indeterminate
                size="64"
              ></v-progress-circular>
            </v-overlay>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import airtable from "../assets/airtable.js"
import mixins from "../assets/mixins.js"
import SocketIOFileClient from "../assets/socketio-file-client.js"
import io from "../assets/socketio.js"
import { firebaseApp, initFirebase } from "../assets/firebase.js"

export default {
  name: "admin",
  mixins: [mixins],
  mounted() {
    let password = localStorage.getItem("firebaseCredentialsPassword")
    !password ? (password = prompt("firebaseCredentialsPassword???")) : null
    if (password) {
      let url = new URL(this.fetchUrl + '/firebaseCredentials')
      url.searchParams.append("password", password)
      fetch(url, {
        method: "GET",
        mode: "cors"
      })
        .then(response => response.json())
        .then(operationResult => {
          if (operationResult.credentials) {
            !localStorage.getItem("firebaseCredentialsPassword")
              ? localStorage.setItem("firebaseCredentialsPassword", password)
              : null

            this.serverResponse = "firebase data fetched"
            this.firebaseCredentials = operationResult.credentials

            initFirebase(this.firebaseCredentials)

            this.fireApp = firebaseApp

            this.dismissAlert()
          }
        })
        .catch(err => {
          this.serverResponse = err
          this.alertType = "error"

          this.dismissAlert()
        })
    }
  },
  computed: {
    language() {
      if (this.both) return "both"
      else if (this.languageSwitch) return "pt"
      else return "en"
    }
  },
  data() {
    return {
      fetchUrl: 
      // window.location.href.indexOf('localhost') > -1
      //   ? 'http://localhost:3000' // local production enviroment for debugging
      //   : 
        'https://login-anantadeva.herokuapp.com', // in production
      videoRecordingPaused: false,
      audioRecordingPaused: false,
      fireApp: null,
      audioFile: null,
      recordedAudio: false,
      recordingAudio: false,
      audioRecordingResumed: false,
      audioStream: null,
      audioDialog: false,
      audioMediaRecorder: null,
      cameraNotFound: false,
      saveCapturedVideo: false,
      recordedVideo: false,
      videoFile: null,
      viewPortWidth: window.innerWidth,
      recordingResumed: false,
      recording: false,
      mediaRecorder: null,
      dialog: false,
      overlayText: null,
      uploadVideo: false,
      post: {
        textPt: null,
        textEn: null,
        image: null,
        textEn: null,
        videoUrl: null,
        audioUrl: null
      },
      overlay: false,
      serverResponse: null,
      alertType: "info",
      languageSwitch: true,
      formData: null,
      both: false,
      recorder: null,
      recordedBlob: null
    }
  },
  methods: {
    setAudioForSave() {
      this.saveCapturedAudio = true
      this.audioDialog = false
    },

    resumeAudioRecording() {
      this.audioMediaRecorder.resume()
      console.log("audio recording resumed")
      this.audioRecordingResumed = true
      this.audioRecordingPaused = false
    },

    pauseAudioRecording() {
      this.audioMediaRecorder.pause()
      console.log("audio recording paused")
      this.audioRecordingResumed = false
      this.audioRecordingPaused = true
    },

    stopAudioRecording() {
      this.audioMediaRecorder.state !== "inactive"
        ? this.audioMediaRecorder.stop()
        : null

      if (this.audioStream.active)
        this.audioStream.getTracks().forEach(track => track.stop())

      this.audioRecordingResumed = false
      this.recordingAudio = false
      this.audioRecordingPaused = false
    },

    closeAndStopAudioCapture() {
      this.audioDialog = false
      this.stopAudioRecording()
      this.resetAudioCapture()
    },

    resetAudioCapture() {
      this.audioMediaRecorder = null
      this.audioStream = null
      this.audioRecordingResumed = false
      this.recordingAudio = false
      this.audioFile = null
      this.saveCapturedAudio = false
      this.audioDialog = false
      this.audioRecordingPaused = false
    },

    startAudioRecord() {
      this.audioMediaRecorder = null
      this.audioStream = null
      this.audioRecordingResumed = false
      this.recordingAudio = false
      this.audioFile = null

      navigator.mediaDevices
        .getUserMedia({
          audio: true
        })
        .then(stream => {
          this.audioStream = stream

          const mimeType = "audio/webm"

          this.audioMediaRecorder = new MediaRecorder(stream, { mimeType })
          let recordedChunks = []

          this.audioMediaRecorder.addEventListener("dataavailable", e => {
            if (e.data.size > 0) recordedChunks.push(e.data)
          })

          this.audioMediaRecorder.addEventListener("stop", e => {
            let blob = new Blob(recordedChunks, { type: mimeType }),
              filename = `voiceRecord_${Date.now()}.webm`,
              audioContext = new AudioContext(),
              reader = new FileReader()

            this.$refs.audioEl.src = URL.createObjectURL(blob)
            // this.$refs.audioEl.oncanplaythrough = () =>
            //   this.$refs.audioEl.play() // debugging purpose only

            reader.onload = e => {
              audioContext.decodeAudioData(reader.result).then(decode => {
                let file = new File([blob], filename, {
                  type: mimeType,
                  lastModified: Date.now()
                })

                this.audioFile = { file, metadata: decode }

                //decode é o metadata
                // this.trigger("recorded", file, decode)
              })
            }
            reader.readAsArrayBuffer(blob)

            // console.log('file',blob)
          })
          this.audioMediaRecorder.start()
          this.audioRecordingResumed = true
          this.recordingAudio = true
        })
        .catch(err => {
          console.error(err)
        })
    },

    getVideoStreamAndStartRecording() {
      this.recordedBlob = null
      navigator.mediaDevices
        .getUserMedia({
          video: true,
          audio: true
        })
        .then(stream => {
          this.resetVideoCapture()
          this.$refs.preview.srcObject = stream
          this.$refs.preview.captureStream =
            this.$refs.preview.captureStream ||
            this.$refs.preview.mozCaptureStream
          return new Promise(
            resolve => (this.$refs.preview.onplaying = resolve)
          )
        })
        .then(() => this.startRecording(this.$refs.preview.captureStream()))
        .then(recordedChunks => {
          this.recordedBlob = new Blob(recordedChunks, { type: "video/webm" })

          this.formData = new FormData()
          this.videoFile = new File(
            [this.recordedBlob],
            "recording_at_" + Date.now(),
            { type: "video/webm" }
          )

          this.formData.append("video", this.videoFile)
          this.recordedVideo = true
        })
        .catch(err => {
          console.error(err)
          if (err.toString() === "NotFoundError: Requested device not found") {
            this.cameraNotFound = true
            this.dialog = false
          }
        })
    },

    resetVideoCapture() {
      if (this.recorder) this.stopRecording()
      this.recorder = null
      this.recordedBlob = null
      this.recordingResumed = null
      this.recording = null
      this.recordedVideo = null
      this.saveCapturedVideo = false
      this.mediaRecorder = null
      this.videoRecordingPaused = false
      this.videoFile = null
    },

    closeAndStopVideoCapture() {
      this.dialog = false
      this.stopRecording()
      this.resetVideoCapture()
    },

    setVideoForSave() {
      this.saveCapturedVideo = true
      this.dialog = false
    },

    resumeRecording() {
      this.recorder.resume()
      console.log("recording resumed")
      this.recordingResumed = true
      this.videoRecordingPaused = false
    },

    pauseRecording() {
      this.recorder.pause()
      console.log("recording paused")
      this.recordingResumed = false
      this.videoRecordingPaused = true
    },

    stopRecording() {
      this.$refs.preview.srcObject.getTracks().forEach(track => track.stop())
      this.recordingResumed = false
      this.recording = false
      this.videoRecordingPaused = false
    },

    startRecording(stream) {
      this.recorder = new MediaRecorder(stream)
      let data = []

      this.recorder.ondataavailable = event => data.push(event.data)
      this.recorder.start()

      this.recording = this.recordingResumed = true
      let stopped = new Promise((resolve, reject) => {
        this.recorder.onstop = resolve
        this.recorder.onerror = event => reject(event.name)
      })

      return Promise.all([stopped]).then(() => data)
    },

    dismissAlert(immediate) {
      setTimeout(
        () => {
          this.serverResponse = null
          this.alertType = "info"
        },
        immediate ? 250 : 15000
      )
    },

    convert(file) {
      if (file) {
        if (file.type.indexOf("video") > -1) {
          // this.uploadVideo = true
          // this.formData = new FormData()

          // this.formData.append("video", file)
          this.videoFile = [file]
        } else if (file.type.indexOf("image") > -1) {
          let reader = new FileReader()
          reader.addEventListener(
            "load",
            () => {
              // Setting up base64 URL on image
              this.post.image = reader.result
            },
            false
          )

          reader.readAsDataURL(file)
        }
      } else {
        // this.uploadVideo = false
        this.videoFile = null
        this.recordedVideo = null
        this.saveCapturedVideo = false
      }
    },

    validateInput() {
      return (
        (this.language === "pt" &&
          this.post.textPt &&
          this.post.textPt.length > 6) ||
        (this.language === "en" &&
          this.post.textEn &&
          this.post.textEn.length > 6) ||
        (this.both &&
          this.post.textPt &&
          this.post.textPt.length > 6 &&
          this.post.textEn &&
          this.post.textEn.length > 6)
      )
    },

    sendPostFetch() {
     

      this.overlay = true
      this.setOverlay("Saving Post")
      fetch(this.fetchUrl + '/setPost' , {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(this.post)
      })
        .then(response => response.json())
        .then(data => {
          this.serverResponse = data
          this.overlay = false
          this.post = {
            textPt: null,
            textEn: null,
            image: null,
            textEn: null,
            videoUrl: null,
            audioUrl: null
          }

          this.formData = null
          
          
          this.resetVideoCapture()
          this.resetAudioCapture()

          this.$refs.imgInput.reset()
          this.$refs.videoInput.reset()

          this.dismissAlert()
        })
        .catch(err => {
          this.serverResponse = err
          this.alertType = "error"

          this.dismissAlert()
        })
    },

    makeXHR() {
      let xhr = new XMLHttpRequest()
      // xhr.open("POST", "http://localhost:3000/uploadVideo")
      xhr.open("POST", "https://login-anantadeva.herokuapp.com/uploadVideo")

      //

      // request state change event
      xhr.onreadystatechange = function() {
        // request completed?
        if (xhr.readyState !== 4) return

        if (xhr.status === 200) {
          // request successful - show response
          console.log(xhr.responseText)
        } else {
          // request error
          console.log("HTTP error", xhr.status, xhr.statusText)
        }
      }

      xhr.onprogress = function() {
        console.log("LOADING: ", xhr.status)
      }

      xhr.onload = function() {
        console.log("DONE: ", xhr.status)
      }
      xhr.timeout = 500000 // 8,33 minutes
      xhr.ontimeout = () => {
        console.log("timeout", xhr.responseURL)
        this.removeOverlay()
      }

      const socket = this.getSocket()

      socket.on("upload-progress", data => {
        this.setOverlay(`Upload progress at ${data.toFixed(2)} %`)
      })

      socket.on("downloadUrl", url => {
        this.post.videoUrl = url
        setTimeout(() => {
          this.sendPostFetch()
          setTimeout(() => {
            this.resetVideoCapture()
          }, 1000)
        }, 500)
      })

      this.overlay = true
      this.setOverlay("Uploading video")
      // start request
      xhr.send(this.formData)
    },

    getSocket() {
      return io("https://login-anantadeva.herokuapp.com") // io("http://localhost:3000")
    },

    setOverlay(text) {
      this.overlay = true
      this.overlayText = text ? text : null
    },

    removeOverlay(text) {
      this.overlay = false
      this.overlayText = null
    },

    savePost() {
      this.post.language = this.language

      if (this.saveCapturedVideo || this.saveCapturedAudio) {
        if (this.saveCapturedAudio && !this.validateInput()) {
          alert(
            "Put at least a title or comment to the audio. Minimum 6 characters"
          )
          return
        }

        this.saveCapturedVideo
          ? this.setOverlay("Sending video")
          : this.setOverlay("Sending audio")

        // const socket = this.getSocket(),
        //   uploader = new SocketIOFileClient(socket)

        // socket.on("upload-progress", data => {
        //   this.setOverlay(`Upload progress at ${data.toFixed(2)} %`)
        // })

        // socket.on("downloadUrl", url => {
        //   setTimeout(() => {
        //     this.sendPostFetch()
        //   }, 500)

        //   if (this.saveCapturedVideo) {
        //     this.post.videoUrl = url
        //   } else {
        //     this.post.audioUrl = url
        //   }
        // })

        // uploader.on("start", function(fileInfo) {
        //   console.log("Start uploading", fileInfo)
        // })
        // uploader.on("stream", fileInfo => {
        //   // console.log( "Streaming... sent " +   fileInfo.sent +   " bytes of " +   fileInfo.size +   " total" )

        //   this.setOverlay(
        //     "Streaming... sent " +
        //       fileInfo.sent +
        //       " bytes of " +
        //       fileInfo.size +
        //       " total"
        //   )
        // })
        // uploader.on("complete", fileInfo => {
        //   console.log("Upload Complete", fileInfo)
        // })
        // uploader.on("error", function(err) {
        //   console.log("Error!", err)
        // })
        // uploader.on("abort", function(fileInfo) {
        //   console.log("Aborted: ", fileInfo)
        // })
        let uploadTask = null
        if (this.saveCapturedVideo) {
          uploadTask = this.fireApp
            .storage()
            .ref()
            .child(this.videoFile.name)
            .put(this.videoFile)
        } else {
          uploadTask = this.fireApp
            .storage()
            .ref()
            .child(this.audioFile.file.name)
            .put(this.audioFile.file)
        }
        uploadTask.on(
          "state_changed",
          snapshot => {
            // Observe state change events such as progress, pause, and resume
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            var progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            // console.log("Upload is " + progress + "% done")
            this.setOverlay("Upload is " + progress + "% done")
            switch (snapshot.state) {
              case this.fireApp.firebase_.storage.TaskState.PAUSED: // or 'paused'
                console.log("Upload is paused")
                break
              case this.fireApp.firebase_.storage.TaskState.RUNNING: // or 'running'
                console.log("Upload is running")
                break
            }
          },
          function(error) {
            // Handle unsuccessful uploads
            switch (error.code) {
              case "storage/unauthorized":
                console.log("User doesn't have permission to access the object")
                break

              case "storage/canceled":
                console.log("User canceled the upload")
                break

              case "storage/unknown":
                console.log(
                  "Unknown error occurred, inspect error.serverResponse"
                )
                break
            }
          },
          () => {
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then( downloadURL => {
                
                console.log(this, downloadURL)
                if (this.saveCapturedVideo)
                  this.post.videoUrl = downloadURL
                else 
                  this.post.audioUrl = downloadURL

                setTimeout(() => {
                  this.sendPostFetch()
                  setTimeout(() => {
                    if (this.saveCapturedVideo)
                      this.resetVideoCapture()
                    else 
                      this.resetAudioCapture()
                  }, 1000)
                }, 500)
              })
          }
        )
      } else if (this.videoFile) {
        
        if (this.videoFile[0].size > 299) {
          //29302669
          let uploadTask = this.fireApp
            .storage()
            .ref()
            .child(this.videoFile[0].name)
            .put(this.videoFile[0])
          uploadTask.on(
            "state_changed",
            snapshot => {
              // Observe state change events such as progress, pause, and resume
              // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
              var progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100
              // console.log("Upload is " + progress + "% done")
              this.setOverlay("Upload is " + progress + "% done")
              switch (snapshot.state) {
                case this.fireApp.firebase_.storage.TaskState.PAUSED: // or 'paused'
                  console.log("Upload is paused")
                  break
                case this.fireApp.firebase_.storage.TaskState.RUNNING: // or 'running'
                  console.log("Upload is running")
                  break
              }
            },
            function(error) {
              // Handle unsuccessful uploads
              switch (error.code) {
                case "storage/unauthorized":
                  console.log(
                    "User doesn't have permission to access the object"
                  )
                  break

                case "storage/canceled":
                  console.log("User canceled the upload")
                  break

                case "storage/unknown":
                  console.log(
                    "Unknown error occurred, inspect error.serverResponse"
                  )
                  break
              }
            },
            function() {
              // Handle successful uploads on complete
              // For instance, get the download URL: https://firebasestorage.googleapis.com/...
              uploadTask.snapshot.ref
                .getDownloadURL()
                .then(function(downloadURL) {
                  // console.log("File available at", downloadURL)
                  this.post.videoUrl = downloadURL
                  setTimeout(() => {
                    this.sendPostFetch()
                    setTimeout(() => {
                      this.resetVideoCapture()
                    }, 1000)
                  }, 500)
                })
            }
          )
        } else {
          this.makeXHR()
        }
      } else {
        this.sendPostFetch()
      }
    }
  }
}
</script>

<style>
#admin {
  width: 100%;
}

.v-alert__content {
  display: flex;
  flex-direction: column;
}

#change-language {
  display: flex;
  justify-content: space-evenly;
}

div.v-alert.flex.v-sheet.theme--dark.info {
  margin: 2%;
}

#audio-video-capture {
  display: flex;
  flex-direction: column;
  width: 45vh;
}

#audio-video-capture button {
  margin: 2% 0px;
}

#audio-preview-area {
  justify-content: space-around;
  min-height: 80px;
}

audio {
  margin: 3% 1%;
}
</style>